<template>
    <div :class="'rsk-form'+(isExpand?'--expand':'')">
        <input :type="type" :placeholder="placeholder" :class="isExpand?'rsk-input rsk-input--expand':'rsk-input rsk-input'" :maxlength="max == null ? -1 : max" :value="modelValue" @input="input"/>
    </div>
</template>
<script>
import { ref } from 'vue';
export default {
    props: {
        type: {
            type: String,
            default: 'text'
        },
        modelValue: {
            type: [String, Number],
            default: ""
        },
        placeholder:{
            type: String,
            default: ""
        },
        isExpand:{
            type: Boolean,
            default: false
        },
        max:String
    },
    setup(props, { emit }) {
        function input( e ) {
          const latestValue = e?.target?.value ?? "";
          emit("update:modelValue", latestValue);
          emit("input", latestValue);
        }

        return {
            ...props,
            input,
        }
    },
}
</script>
